import React, { Component } from "react";
//import auth from "../services/authService";
//

import { toast } from "react-toastify";
import Table from "./common/table";
import Like from "./common/like";
import Lock from "./common/lock";
import Moment from "react-moment";
import TextArea from "./common/textArea";
import TextareaAutosize from "react-textarea-autosize";
import { sclist } from "../sc.json";
import { sclistOld } from "../sc_old.json";
import { isBlockedShortCode } from "../utils/shortCodeStatus";
import { appendQuickReply } from "../utils/quickReplies";
import CopyableText from "./common/copyableText";
//import { toast } from "react-toastify";
//import MessageCount from "./common/messageCount";
import {
  LockDream_Mob,
  DreamAdmin,
  DreamAdminMuraqeeb,
  PostDream_,
  PersonalStatus,
  CustomerRate,
  PrivatePerson,
} from "../services/dreamNewService";
import { saveOPTOUT } from "../services/dreamService";

const shortCodes = [...sclist, ...sclistOld];
const getShortCodeTextClass = (shortCode) =>
  shortCode ? `row${shortCode}color` : "";
class DreamsTableShow extends Component {
  state = {
    // data: {
    //   correctWord: "",
    //   wrongWord: "",

    //   filedId: ""
    // },
    modalIsOpen: false,
    errors: {},
    dream: [],
    replyMsg: "",
    MT_Englsih: "",
    personStatus: "",

    disableSent: false,
    shortCodeFilter: "all",
    replyDrafts: {},
  };



  getDefaultMessage = (dream) => {
    let defaultMessage = "";
    const shortCode = String(dream.MOShortCode); // Ensure MOShortCode is a string

    if (dream.MT_Reply_Msg) {
      defaultMessage = dream.MT_Reply_Msg;
    } else if (dream.MsgRegFroSend === 1 && !dream.isRedyToSent) {
      defaultMessage = dream.MT_Reply_Msg;
    } else if (dream.MsgRegFroSend === 1 && dream.isSent) {
      defaultMessage = dream.ReplyMsg2;
    } else if (dream.MsgRegFroSend === 2) {
      defaultMessage = dream.ReplyMsg3;
    } else if (dream.MsgRegFroSend === 3) {
      defaultMessage = dream.ReplyMsg3;
    } else if (dream.MsgRegFroSend === 4) {
      defaultMessage = dream.ReplyMsg4;
    }



    if (["4022", "2337", "6877", "4142"].includes(shortCode) && !dream.isRedyToSent) {
      defaultMessage += `\n\n تنويه مهم: هذا الرقم للتفسير ${shortCode} أصبح قديماً، وتم استبداله برقم 7994 لتفسير الأحلام الجديدة، مع إضافة خدمة مميزة جداً وهي خدمة جديدة سريعة جداً عبر وتساب 0507354835 يصل التفسير الكتابي خلال أقل من ساعة، برسوم أوفر 25% مقارنة بالأس أم أس.`;
    } else if (["4024", "6055"].includes(shortCode) && !dream.isRedyToSent) {
      defaultMessage += `\n\n تنويه مهم: هذا الرقم للتفسير ${shortCode} أصبح قديماً، وتم استبداله برقم 7994 لتفسير الأحلام الجديدة، مع إضافة خدمة مميزة جداً وهي خدمة جديدة سريعة جداً عبر وتساب 0507354835 يصل التفسير الكتابي خلال أقل من ساعة، برسوم أوفر 25% مقارنة بالأس أم أس.`;
    } else if (["3900", "2304", "3772"].includes(shortCode) && !dream.isRedyToSent) {
      defaultMessage += "";
    }


    return defaultMessage;
  };

  handleChangeInput =
    (dream) =>
      ({ currentTarget: input }) => {
        let name = input.name;

        if (dream.isSent) {
          if (dream["MsgRegFroSend"] === 1) {
            dream["MsgRegFroSend"] = 2;
            name = "ReplyMsg2";
          } else if (dream["MsgRegFroSend"] === 2) {
            dream["MsgRegFroSend"] = 3;
            name = "ReplyMsg3";
          } else if (dream["MsgRegFroSend"] === 3) {
            dream["MsgRegFroSend"] = 4;
            name = "ReplyMsg4";
          } else {
            dream["MsgRegFroSend"] = 4;
            name = "ReplyMsg4";
          }
          dream["isSent"] = false;
        }

        dream[name] = input.value;
        this.setState((state) => ({
          dream: dream,
          replyDrafts: {
            ...state.replyDrafts,
            [this.getReplyDraftKey(dream, name)]: input.value,
          },
        }));

        if (this.props.onChangeText) {
          this.props.onChangeText(dream, name, input.value);
        }
      };

  handleChangeInputFocus =
    (dream) =>
      ({ target: input }) => {
        dream[input.name] = input.value;
        this.setState({ dream: dream });
      };

  handleChangeInputBlur =
    (dream) =>
      ({ currentTarget: input }) => {
        const name =
          input.name === "MT_Reply_Msg" ? this.getReplyInputName(dream) : input.name;
        dream[name] = input.value;
        this.setState((state) => ({
          dream: dream,
          replyDrafts: {
            ...state.replyDrafts,
            [this.getReplyDraftKey(dream, name)]: input.value,
          },
        }));

        if (this.props.onChangeText) {
          this.props.onChangeText(dream, name, input.value);
        }
      };

  handleChangeInput1 =
    (dream) =>
      ({ target: input }) => {
        dream[input.name] = input.value;
        this.setState({ dream: dream });

        if (this.props.onChangeText) {
          this.props.onChangeText(dream, input.name, input.value);
        }
      };

  handleShortCodeFilterChange = (event) => {
    this.setState({ shortCodeFilter: event.target.value });
  };

  getFilteredDreams = () => {
    const { dreams } = this.props;
    const { shortCodeFilter } = this.state;

    if (!dreams) return [];

    if (shortCodeFilter === "old") {
      return dreams.filter((dream) => isBlockedShortCode(dream.MOShortCode));
    }

    if (shortCodeFilter === "ahlamkom") {
      return dreams.filter((dream) => !isBlockedShortCode(dream.MOShortCode));
    }

    return dreams;
  };
  handleOptOut = async (mobile) => {
    const mob = { Mobile: mobile };
    try {
      await saveOPTOUT(mob);
      toast.info("تم  حذف الرقم من الترويج", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    } catch (ex) {
      toast.error("يوجد خطأ بالحفظ ", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
      if (ex.response && ex.response.status === 404)
        toast.error("This mob has already been deleted.");
    }
  };
  handleGreeting = (e) => { };

  getReplyInputName = (dream) => {
    if (dream.MsgRegFroSend === 2) return "ReplyMsg2";
    if (dream.MsgRegFroSend === 3) return "ReplyMsg3";
    if (dream.MsgRegFroSend === 4) return "ReplyMsg4";
    return "MT_Reply_Msg";
  };

  getReplyDraftKey = (dream, name = this.getReplyInputName(dream)) =>
    `${dream.ReplyID}:${name}`;

  getReplyInputValue = (dream) => {
    const name = this.getReplyInputName(dream);
    const draftKey = this.getReplyDraftKey(dream, name);

    if (this.state.replyDrafts.hasOwnProperty(draftKey)) {
      return this.state.replyDrafts[draftKey];
    }

    if (dream[name] !== undefined && dream[name] !== null) {
      return dream[name];
    }

    return this.getDefaultMessage(dream) || "";
  };

  getReplyInputLength = (dream) => {
    return this.getReplyInputValue(dream).length;
  };

  handleUseQuickContactReply = (dream) => {
    const name = this.getReplyInputName(dream);
    const nextMessage = appendQuickReply(this.getReplyInputValue(dream));
    dream[name] = nextMessage;
    this.setState((state) => ({
      dream,
      replyDrafts: {
        ...state.replyDrafts,
        [this.getReplyDraftKey(dream, name)]: nextMessage,
      },
    }));

    if (this.props.onChangeText) {
      this.props.onChangeText(dream, name, nextMessage);
    }
  };

  handelSelectCustomerRate = async (event, dream) => {
    ////console.log(event.target.value);
    ////console.log(dream);
    // const btn = { title: event.target.value, name:"8"  };
    //  this.props.onItemSelect(btn,"8");
    dream.customerRate = event.target.value;
    this.props.OnAction(dream);
    const stat = await CustomerRate(dream);
  };

  handelSelectPrivate = async (dream) => {
    dream.isprivate = !dream.isprivate;

    this.props.OnAction(dream);
    const stat = await PrivatePerson(dream);
  };

  handleToAdmin = async (dream, status) => {
    try {
      if (status === "حجز") {
        if (dream["islockAdmin"]) {
          dream["islockAdmin"] = false;
          dream.userlockDate = null;
          dream.Userlock = "";
          dream.ReplyUserName = "";

          dream.islock = false;
          this.props.OnAction(dream);
          const stat = await DreamAdmin(dream);
          return;
        } else {
          dream["islockAdmin"] = true;
          dream.userlockDate = new Date();
          dream.Userlock = "adib@salmustasharak.com";
          dream.ReplyUserName = "adib@salmustasharak.com";

          dream.islock = true;
          this.props.OnAction(dream);
          const stat = await DreamAdmin(dream);
          return;
        }
        //"نوع الزبون"
      } else if (status === "حجز لمنى") {
        dream["islockAdmin"] = true;
        dream.userlockDate = new Date();
        dream.Userlock = "mohannad@salmustasharak.com";
        dream.ReplyUserName = "mohannad@salmustasharak.com";

        dream.islock = true;
        this.props.OnAction(dream);
        const stat = await DreamAdmin(dream);
        return;
      } else if (status === "حجز لأديب") {
        dream["islockAdmin"] = true;
        dream.userlockDate = new Date();
        dream.Userlock = "adib@salmustasharak.com";
        dream.ReplyUserName = "adib@salmustasharak.com";

        dream.islock = true;
        this.props.OnAction(dream);
        const stat = await DreamAdmin(dream);
        return;
      }
      else if (status === "فك للشيخ أديب") {
        ////console.log(dream.ReplyUserName);
        dream["MT_Arabic"] = dream.ReplyUserName;
        dream["ReplyUserName"] = "adib@salmustasharak.com";
        dream["islockAdmin"] = true;
        dream.userlockDate = new Date();
        dream.Userlock = "adib@salmustasharak.com";
        this.props.OnAction(dream);
        const stat = await DreamAdmin(dream);
        return;
      } else if (status === "حذف أدمن") {
        dream["MT_Date"] = new Date();
        dream["ReplyDate"] = new Date();
        dream["isdelete"] = true;

        dream["ReplyUserName"] = this.props.user;
        this.props.OnAction(dream);
        const stat = await DreamAdmin(dream);
        return;
      } else if (status === "الغاء الحذف") {
        dream["MT_Date"] = null;
        dream["ReplyDate"] = null;
        dream["isdelete"] = false;

        dream["ReplyUserName"] = "";
        this.props.OnAction(dream);
        const stat = await DreamAdmin(dream);
        return;
      } else if (status === "الغاء الارسال") {
        const currentDate = new Date();
        currentDate.setSeconds(currentDate.getSeconds() - 50);
        if (currentDate > dream.MT_Date) {
          toast.error("لا يمكن ايقاف الرسالة", {
            position: toast.POSITION.BOTTOM_LEFT,
          });
          return;
        }
        dream["isRedyToSent"] = false;
        this.props.OnAction(dream);
        const stat = await DreamAdmin(dream);
        return;
        //"فك الحلم"
      } else if (status === "فك الحلم") {
        dream["IsReply"] = false;

        this.props.OnAction(dream);
        const stat = await DreamAdmin(dream);
        return;
      } else {
        dream["MT_Date"] = new Date();
        dream["ReplyDate"] = new Date();
        dream["isRedyToSent"] = false;
        dream["MsgRegFroSend"] = 1;
        dream["MT_Arabic"] = status;
        dream["MT_NoOfMsg"] = dream["MT_Arabic"].length;
        dream["IsPending"] = true;
        dream["IsReply"] = true;
        dream["ReplyUserName"] = this.props.user;
        dream["userlockDate"] = new Date();
        dream["Userlock"] = this.props.user.replace("@salmustasharak.com", "");
        this.props.OnAction(dream);
        const stat = await DreamAdmin(dream);
      }
      toast.success("تم الارسال بنجاح", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    } catch (ex) {
      toast.error("حدث خطأ ", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    }
  };

  handleToAdmin1 = async (dream, status) => {
    try {
      if (status === "حجز لمنى") {
        dream["islockAdmin"] = true;
        dream.userlockDate = new Date();
        dream.Userlock = "mohannad@salmustasharak.com";
        dream.ReplyUserName = "mohannad@salmustasharak.com";
        dream.IsReply = false;
        dream.islock = true;
        this.props.OnAction(dream);
        const stat = await DreamAdmin(dream);
        return;
      }
      toast.success("تم الارسال بنجاح", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    } catch (ex) {
      toast.error("حدث خطأ ", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    }
  };

  handlePS = async () => {
    if (this.state.dream) {
      const stat = await PersonalStatus(this.state.dream);
    } else {
      toast.error("لم تغير الحالة", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    }
  };
  HandleSendMsg = async () => {
    try {
      const dream = this.state.dream;
      dream["MT_Date"] = new Date();
      dream["isRedyToSent"] = true;

      dream["MsgRegFroSend"] = 1;
      this.props.OnAction(dream);
      const stat = await DreamAdminMuraqeeb(dream);
      toast.success("تم الارسال بنجاح", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    } catch (ex) {
      toast.error("حدث خطأ ", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    }
  };

  HandleSendMsgTOMuraqeb = async () => {
    try {
      const dream = this.state.dream;
      dream["MT_Date"] = new Date();
      dream["isRedyToSent"] = false;
      dream["MsgRegFroSend"] = 1;
      this.props.OnAction(dream);
      const stat = await DreamAdminMuraqeeb(dream);
      toast.success("تم الارسال بنجاح", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    } catch (ex) {
      toast.error("حدث خطأ ", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    }
  };

  render() {
    let columns;
    const pStyle = {
      fontSize: "22pt",
      direction: "rtl",
      fontWeight: "bold",
      color: "Red",
    };
    const pStyle2 = {
      fontSize: "22pt",
      direction: "rtl",
      fontWeight: "bold",
      color: "DarkRed",
    };
    const wStyle = {
      wordWrap: "break-word",
      fontWeight: "bold",
      fontSize: "25pt",
    };
    columns = [
      {
        path: "MT_Date",
        label: "اجراءات",
        content: (dream) => (
          <div className="row flex-nowrap">
            <div className="col-12 col-lg-12  col-md-12 col-sm-12 col-xs-12 text-right  flex-nowrap">
              {this.props.pcode !== 999 && !dream.isRedyToSent && (
                <div>
                  <button
                    type="button"
                    className="btn btn-secondary   btn-block"
                    onClick={() => this.handleToAdmin(dream, "مكرر")}
                  >
                    مكرر{" "}
                  </button>
                </div>
              )}
              {this.props.pcode === 999 &&
                this.props.user !== "adib@salmustasharak.com" && (
                  <div>
                    <button
                      type="button"
                      className="btn btn-warning   btn-block"
                      onClick={() => this.handleToAdmin(dream, "العاجل")}
                    >
                      العاجل{" "}
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary   btn-block"
                      onClick={() => this.handleToAdmin(dream, "مكرر")}
                    >
                      مكرر{" "}
                    </button>
                  </div>
                )}
              <br></br>

              {this.props.pcode === 999 && (
                <div>
                  {dream.IsReply && !dream.isRedyToSent && (
                    <button
                      type="button"
                      className="btn btn-warning   btn-block"
                      onClick={() => this.handleToAdmin(dream, "فك الحلم")}
                    >
                      فك الحلم{" "}
                    </button>
                  )}
                  {!dream.isdelete && !dream.isSent && (
                    <button
                      type="button"
                      className="btn btn-danger   btn-block"
                      onClick={() => this.handleToAdmin(dream, "حذف أدمن")}
                    >
                      {" "}
                      حذف أدمن{" "}
                    </button>
                  )}
                  {dream.isdelete && (
                    <button
                      type="button"
                      className="btn btn-danger   btn-block"
                      onClick={() => this.handleToAdmin(dream, "الغاء الحذف")}
                    >
                      الغاء الحذف
                    </button>
                  )}
                  {!dream.isSent && dream.isRedyToSent && (
                    <div>
                      <button
                        type="button"
                        className="btn btn-primary   btn-block"
                        onClick={() => this.handleToAdmin(dream, "الغاء الارسال")}
                      >
                        الغاء الارسال{" "}
                      </button>
                      <br></br>
                      <Moment
                        parse="YYYY-MM-DD HH:mm"
                        format="YYYY-MM-DD hh:mm A"
                        className="text-success"
                      >
                        {dream.MT_Date}
                      </Moment>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        ),
      },
      {
        path: "MO_Message",
        label: "الرسالة",
        content: (dream) => (
          <div className="row flex-nowrap">
            <div className="col-12 col-lg-12  col-md-12 col-sm-12 col-xs-12 text-right  flex-nowrap">
              {this.props.pcode === 999 ? (
                <div>
                  <button
                    type="button"
                    className="btn btn-danger   btn-block"
                    onClick={() => this.handlePS()}
                  >
                    {" "}
                    حفظ الحالة{" "}
                  </button>
                  <TextareaAutosize
                    minRows={1}
                    className="form-control"
                    rows={2}
                    style={pStyle2}
                    id={"PersonStatus" + dream.ReplyID}
                    name="PersonStatus"
                    onChange={this.handleChangeInput1(dream)}
                    onFocus={this.handleChangeInputFocus(dream)}
                    onBlur={this.handleChangeInputBlur(dream)}
                    defaultValue={dream.PersonStatus}
                    placeholder="اكتب هنا الحالة "
                  //  ref={(input) => { this.nameInput = input; }}
                  />
                </div>
              ) : (
                dream.PersonStatus
              )}
              <br></br>

              <div
                className={
                  dream.MOShortCode === 7570 || dream.MOShortCode === 4060
                    ? "bg-warning text-dark"
                    : "bg-light text-dark"
                }
              >
                <h4 className="text-danger">
                  {" "}
                  {dream.PersonStatus ? dream.PersonStatus + " - " : ""}{" "}
                  {dream.RefNo}{" "}
                </h4>
                {dream.userlockDate && (
                  <h4 className="text-primary">
                    {" "}
                    {"   "}{" "}
                    {dream.Userlock &&
                      dream.Userlock.replace("@salmustasharak.com", "")}
                    {"  ( "}{" "}
                    {dream.userlockDate && (
                      <Moment
                        parse="YYYY-MM-DD HH:mm"
                        format="YYYY-MM-DD hh:mm A"
                        className="text-success"
                      >
                        {dream.userlockDate}
                      </Moment>
                    )}{" "}
                    {"  ) "}{" "}
                  </h4>
                )}

                {dream.IsNew === false ? (
                  ""
                ) : (
                  <i className="fa fa fa-star fa-4x text-warning" />
                )}

                <div
                  className={`text-right ${getShortCodeTextClass(
                    dream.MOShortCode
                  )}`}
                >
                  <div style={wStyle} dangerouslySetInnerHTML={{
                    __html: dream.ReplyMsg4
                  }}></div>
                  {dream.MT_Reply_Msg && dream.isSent && (
                    <h4 className="text-danger"> {dream.MT_Reply_Msg}</h4>
                  )}
                  {dream.ReplyMsg2 && (
                    <h4 className="text-danger"> {dream.ReplyMsg2}</h4>
                  )}
                  {dream.ReplyMsg3 && (
                    <h4 className="text-danger"> {dream.ReplyMsg3}</h4>
                  )}

                  <h4> {dream.MufasserMsg}</h4>
                  <hr></hr>
                  <h4> {dream.ReplyMsg2}</h4>
                  <br />

                  {this.props.pcode === 999 && (
                    <div>


                      {dream.IsReply && (


                        <TextareaAutosize
                          minRows={4}
                          className="form-control  input-lg"
                          style={pStyle}
                          rows={4}
                          id={"MT_Reply_Msg" + dream.ReplyID}
                          name={this.getReplyInputName(dream)}
                          onChange={this.handleChangeInput(dream)}
                          onFocus={this.handleChangeInputFocus(dream)}
                          onBlur={this.handleChangeInputBlur(dream)}
                          value={this.getReplyInputValue(dream)}

                        />
                      )}
                      <br></br>
                      {dream.IsReply &&
                        this.state.dream["ReplyID"] === dream.ReplyID ? (
                        <div className="form-group">
                          <span className="label label-primary">
                            عدد الحروف{" "}
                            {this.getReplyInputLength(dream)}{" "}
                            - عدد الرسائل{" "}
                            {this.getReplyInputLength(dream) &&
                              this.getReplyInputLength(dream) < 71
                              ? 1
                              : Math.ceil(
                                this.getReplyInputLength(dream) / 63
                              )}
                          </span>
                          <br />
                          <br></br>
                          <div className="row p-10">
                            <div className="col-4  text-left m-10">
                              <button
                                onClick={() =>
                                  this.HandleSendMsgTOMuraqeb(dream)
                                }
                                className="btn text-right btn-success btn-lg"
                              >
                                ارسال للتدقيق
                              </button>
                            </div>
                            <div className="col-4 text-center m-10">
                              <button
                                type="button"
                                className="btn text-right btn-info btn-lg"
                                onClick={() =>
                                  this.handleUseQuickContactReply(dream)
                                }
                                title="إضافة نص التواصل في آخر خانة الرد"
                              >
                                <i
                                  className="fa fa-commenting-o"
                                  aria-hidden="true"
                                />{" "}
                                نص التواصل
                              </button>
                            </div>
                            <div className="col-4   text-right m-30">
                              <button
                                onClick={() => this.HandleSendMsg(dream)}
                                className="btn text-right btn-success btn-lg"
                              >
                                ارسال
                              </button>
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                      <br />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        ),
      },
      {
        path: "MT_Mobil",
        label: "المعلومات",
        content: (dream) => (
          <div className="row flex-nowrap">
            <div className="col-12 col-lg-12  col-md-12 col-sm-12 col-xs-12 text-right flex-nowrap">
              {dream.customerRate === 2222 ? (
                <img
                  src={require("./img/s1.jpg")}
                  alt="Fjords"
                  style={{ width: "70px", height: "70px", cursor: "pointer" }}
                />
              ) : (
                ""
              )}
              {this.props.pcode > 10 ? (
                <div
                  className={
                    1000 === dream.customerRate
                      ? "bg-1"
                      : 100 === dream.customerRate || 0 === dream.customerRate
                        ? ""
                        : 500 === dream.customerRate
                          ? "bg-2"
                          : 1 === dream.customerRate
                            ? "bg-3"
                            : 9 === dream.customerRate
                              ? "bg-4"
                              : 2 === dream.customerRate
                                ? "bg-5"
                                : 3 === dream.customerRate
                                  ? "bg-6"
                                  : ""
                  }
                >
                  {this.props.pcode === 999 ? (
                    <h4>
                      <select
                        className="selectpicker"
                        value={dream.customerRate}
                        onChange={(e) =>
                          this.handelSelectCustomerRate(e, dream)
                        }
                      >
                        <option
                          value="100"
                          key="100"
                          className={
                            100 === dream.customerRate ||
                              0 === dream.customerRate
                              ? "list-group-item active"
                              : "list-group-item"
                          }
                        >
                          عادي
                        </option>

                        <option
                          value="1000"
                          key="1000"
                          className={
                            1000 === dream.customerRate
                              ? "list-group-item active"
                              : "list-group-item"
                          }
                        >
                          مهم جداً
                        </option>
                        <option
                          value="500"
                          key="500"
                          className={
                            500 === dream.customerRate
                              ? "list-group-item active"
                              : "list-group-item"
                          }
                        >
                          أحلامه كثيرة جداً
                        </option>

                        <option
                          value="4"
                          key="4"
                          className={
                            4 === dream.customerRate
                              ? "list-group-item active"
                              : "list-group-item"
                          }
                        >
                          ثرثرة وسيئ
                        </option>
                        <option
                          value="9"
                          key="9"
                          className={
                            9 === dream.customerRate
                              ? "list-group-item active"
                              : "list-group-item"
                          }
                        >
                          عجول+عاجل
                        </option>
                        <option
                          value="1"
                          key="1"
                          className={
                            1 === dream.customerRate
                              ? "list-group-item active"
                              : "list-group-item"
                          }
                        >
                          عجول جداً
                        </option>
                        <option
                          value="2222"
                          key="2222"
                          className={
                            2222 === dream.customerRate
                              ? "list-group-item active"
                              : "list-group-item"
                          }
                        >
                          خدمة التفسير سريع
                        </option>
                        <option
                          value="2"
                          key="2"
                          className={
                            2 === dream.customerRate
                              ? "list-group-item active"
                              : "list-group-item"
                          }
                        >
                          للحذف الفوري
                        </option>

                        <option
                          value="3"
                          key="3"
                          className={
                            3 === dream.customerRate
                              ? "list-group-item active"
                              : "list-group-item"
                          }
                        >
                          الرد
                        </option>
                      </select>
                    </h4>
                  ) : (
                    ""
                  )}{" "}
                  &nbsp;&nbsp;{" "}
                  {this.props.pcode === 999 ? (
                    <i
                      onClick={() => this.props.onOpenModel(dream)}
                      style={{ cursor: "pointer" }}
                      className="fa fa-database fa-lg"
                      aria-hidden="true"
                    />
                  ) : (
                    ""
                  )}
                  <div
                    className={`text-right ${getShortCodeTextClass(
                      dream.MOShortCode
                    )}`}
                  >
                    <button
                      id={dream.ReplyID}
                      type="button"
                      className="btn btn-primary   btn-block "
                      onClick={() => this.props.onGetAll(dream.MT_Mobil)}
                    >
                      {" "}
                      الرد
                    </button>
                    {this.props.pcode === 999 ? (
                      <h4>
                        {" "}
                        {shortCodes.map(
                        (sc) =>
                          sc.sc === dream.MOShortCode && (
                            <div>
                              {" "}
                              {sc.details} <br />
                              {sc.sc}{" "}
                              {isBlockedShortCode(sc.sc) ? "❌" : "✅"}
                            </div>
                          )
                      )}{" "}
                        &nbsp;&nbsp;{" "}
                      </h4>
                    ) : (
                      ""
                    )}
                    <h4>
                      {this.props.pcode === 999 ? (
                        <CopyableText value={dream.MT_Mobil} />
                      ) : (
                        "+971*****" + dream.MT_Mobil.substring(9)
                      )}
                    </h4>

                    <button
                      type="button"
                      className="btn    btn-block "
                      onClick={() => this.props.onGetAll(dream.MT_Mobil)}
                    >
                      {sclist.map((shortCode) => (
                        <React.Fragment key={shortCode.sc}>
                          <span className={`badge badge-${shortCode.sc}`}>
                            <h4>
                              {
                                this.props.orginalDreams.filter(
                                  (x) =>
                                    x.MT_Mobil === dream.MT_Mobil &&
                                    x.MOShortCode === shortCode.sc
                                ).length
                              }
                            </h4>
                          </span>{" "}
                        </React.Fragment>
                      ))}
                    </button>

                    <h4 className="col align-self-start">
                      {this.props.pcode === 999 && (
                        <img
                          src={require("./img/OPTOUT.jpg")}
                          alt="Fjords"
                          style={{
                            width: "40px",
                            height: "40px",
                            cursor: "pointer",
                          }}
                          onClick={() => this.handleOptOut(dream.MT_Mobil)}
                        />
                      )}
                    </h4>
                    <h4>
                      <Moment
                        parse="YYYY-MM-DD HH:mm"
                        format="YYYY-MM-DD hh:mm A"
                        className="text-primary"
                      >
                        {dream.MO_Date}
                      </Moment>
                    </h4>
                    {this.props.pcode === 999 && (
                      <div>
                        <h4>
                          <h4>
                            {dream.ReplyUserName &&
                              dream.ReplyUserName.replace(
                                "@salmustasharak.com",
                                ""
                              )}
                          </h4>
                          <Like
                            liked={dream.isprivate}
                            onClick={() => this.handelSelectPrivate(dream)}
                          />{" "}
                          &nbsp;&nbsp;{" "}
                          <Lock
                            locked={dream.islockAdmin}
                            onClick={() => this.handleToAdmin(dream, "حجز")}
                          />
                        </h4>
                        {dream.MT_Date && (
                          <Moment
                            parse="YYYY-MM-DD HH:mm"
                            format="YYYY-MM-DD hh:mm A"
                            className="text-warning"
                          >
                            {dream.MT_Date}
                          </Moment>
                        )}
                        <br></br>
                        {!dream.IsReply && (
                          <div>
                            <button
                              type="button"
                              className="btn btn-warning   btn-block"
                              onClick={() =>
                                this.handleToAdmin(dream, "حجز لمنى")
                              }
                            >
                              حجز لمنى{" "}
                            </button>
                            <br></br>



                            <br></br>
                            <button
                              type="button"
                              className="btn btn-success   btn-block"
                              onClick={() =>
                                this.handleToAdmin(dream, "حجز لأديب")
                              }
                            >
                              حجز لأديب{" "}
                            </button>
                          </div>
                        )}

                        {dream.IsReply && !dream.isSent && (
                          <div>
                            <button
                              type="button"
                              className="btn btn-warning   btn-block"
                              onClick={() =>
                                this.handleToAdmin1(dream, "حجز لمنى")
                              }
                            >
                              حجز لمنى{" "}
                            </button>
                            <br></br>

                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        ),
      },
    ];

    const { onSort, sortColumn } = this.props;
    const filteredDreams = this.getFilteredDreams();

    return (
      <React.Fragment>
        <div className="filter-row">
          <div className="filter-label">فلترة الشورت كود</div>
          <select
            className="selectpicker filter-select"
            value={this.state.shortCodeFilter}
            onChange={this.handleShortCodeFilterChange}
          >
            <option value="all">الكل</option>
            <option value="old">شورت كود قديم</option>
            <option value="ahlamkom">شورت كود أحلامكم</option>
          </select>
        </div>
        <Table
          columns={columns}
          data={filteredDreams}
          sortColumn={sortColumn}
          onSort={onSort}
        />
      </React.Fragment>
    );
  }
}

export default DreamsTableShow;



// WEBPACK FOOTER //
// ./src/components/dreamsTableShow.jsx